import EcoLink from 'eco-design/base/eco-link';
import gtm from 'eco-design-reliance/gtm';
import React from 'react';
import { getCardAnimation, getTarget } from '../common';
import './index.scss';

interface Props {
    prefixCls: string;
    item: any;
    title: string;
}

const getChildren = (item: any) => {
    const subs = item?.subs || [];
    if (subs.length > 0) return subs;
    return item?.heading
        ? [
              {
                  id: item.id,
                  name: item.heading,
                  url: item.url,
              },
          ]
        : [];
};

const CardTypeD: React.FC<Props> = ({ prefixCls, item, title }) => {
    const groups = (item?.subs || [])
        .map((group: any) => ({
            ...group,
            children: getChildren(group),
        }))
        .filter((group: any) => group.heading || group.children.length > 0);

    if (groups.length === 0) return <div className={`${prefixCls}-card-type-d`}></div>;

    return (
        <div className={`${prefixCls}-card-type-d`}>
            <div className={`${prefixCls}-card-type-d__grid`}>
                {groups.map((group: any, groupIndex: number) => {
                    const shouldShowHeading = group.children.length !== 1;
                    return (
                        <div
                            className={`${prefixCls}-card-type-d__group ${!shouldShowHeading ? `${prefixCls}-card-type-d__group-single` : ''}`}
                            style={{
                                animation: getCardAnimation(groupIndex),
                            }}
                            key={group.id || groupIndex}
                        >
                            {shouldShowHeading && group.heading && <div className={`${prefixCls}-card-type-d__heading`}>{group.heading}</div>}
                            <div className={`${prefixCls}-card-type-d__links`}>
                                {group.children.map((child: any, childIndex: number) => {
                                    const text = child.name || child.heading;
                                    const linkClassName = `${prefixCls}-card-type-d__link GtmModuleData-btn-href header-nvd-t3-text`;
                                    if (!child.url) {
                                        return (
                                            <div className={linkClassName} key={child.id || childIndex}>
                                                {text}
                                            </div>
                                        );
                                    }
                                    return (
                                        <EcoLink
                                            className={linkClassName}
                                            href={child.url}
                                            target={getTarget(child.url)}
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'top_third_navigation',
                                                position: 'Header Navigation',
                                                navigation_name: `${title}_${group.heading || ''}_${text}`,
                                                list_name: group.heading || title,
                                                __btn_id1: `header-nvd-t3-text`,
                                                __btn_id2: child.url || text,
                                                __btn_type: 'href',
                                            }}
                                            onClick={() => {
                                                gtm.push({
                                                    event: 'uaEvent',
                                                    event_name: 'top_third_navigation',
                                                    navigation_name: `${title}_${group.heading || ''}_${text}`,
                                                    __btn_id1: `header-nvd-t3-text`,
                                                    __btn_id2: child.url || text,
                                                    __btn_type: 'href',
                                                });
                                            }}
                                            key={child.id || childIndex}
                                        >
                                            {text}
                                        </EcoLink>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CardTypeD;
